<template>
  <div id="supportConfirm">
    <dd-header />
    <h2 class="hakotan_title">お問い合わせ内容確認</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <section class="support_section">
            <div class="support_confirm_area">
              <div>
                <ul>
                  <li>
                    <div class="confirm_label">{{label.supportTitle}}</div>
                    <div v-for="support in supportData.supportTitle" :key="support">
                      <div class="confirm_text">{{support}}</div>
                    </div>
                  </li>
                  <li>
                    <div class="confirm_label">{{label.supportBody}}</div>
                    <div class="confirm_text">{{supportData.supportBody}}</div>
                  </li>
                  <li>
                    <div class="confirm_label">{{label.userName}}</div>
                    <div class="confirm_text">{{supportData.userLastName}} {{supportData.userFirstName}}</div>
                  </li>
                  <li>
                    <div class="confirm_label">{{label.userNameKana}}</div>
                    <div class="confirm_text">{{supportData.userLastNameKana}} {{supportData.userFirstNameKana}}</div>
                  </li>
                  <li>
                    <div class="confirm_label">{{label.tel}}</div>
                    <div class="confirm_text">{{supportData.tel}}</div>
                  </li>
                  <li>
                    <div class="confirm_label">{{label.email}}</div>
                    <div class="confirm_text">{{supportData.email}}</div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="control_btn_area">
              <!-- <div>※自動メールにて返信しますので、「@domans.co.jp」からのメールを受信許可に設定してください。</div> -->
              <div class="detail_btn2" @click="goBack()">戻る</div>
              <div class="detail_btn2 btn_color" @click="complete()">送信</div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- <dd-image-viewer-model /> -->
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import DcFooter from '../components/common/DcFooter'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'
import DDLeftMenu from '../components/top/DcLeftMenu'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'SupportConfirm',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'supportConfirm',
      supportData: {},
      label: {
        supportTitle: 'お問い合わせ内容',
        supportBody: 'メッセージ',
        userName: '氏名',
        userNameKana: '氏名（カナ）',
        tel: '電話番号（半角、ハイフンなし）',
        email: 'メールアドレス'
      }
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    complete: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        supportTitle: this.supportData.supportTitle,
        supportBody: this.supportData.supportBody,
        userLastName: this.supportData.userLastName,
        userFirstName: this.supportData.userFirstName,
        userLastNameKana: this.supportData.userLastNameKana,
        userFirstNameKana: this.supportData.userFirstNameKana,
        email: this.supportData.email,
        tel: this.supportData.tel
      }

      axios.post(DC_URL.SUPPORT + '/ya_complete', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$router.push('/support/complete')
          }
        }).catch(error => {
          Api.handleError(error)
          this.$router.push('/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    fetchData: function () {
      if (this.$route.params.supportData) {
        this.supportData = this.$route.params.supportData
      } else {
        this.supportData = App.getLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA)
      }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcSupportConfirm.vue